const translations = {
    compliant: 'Compliant',
    due: 'Due',
    notReported: 'N/A — not reported',
    ok: 'OK',
    outdated: 'Outdated'
};

export default translations;
